namespace Gamification.Gamification {
    export interface UtentiParametriGlobaliRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoParametriGlobali?: number;
        IdUtenteProdotto?: number;
        IdentifierPunteggio?: string;
        PunteggioNome?: string;
        PunteggioValore?: number;
        IdentifierCrediti?: string;
        CreditiNome?: string;
        CreditiValore?: number;
        IdentifierEsperienza?: string;
        EsperienzaNome?: string;
        EsperienzaValore?: number;
        IdentifierLivello?: string;
        Livello?: number;
    }

    export namespace UtentiParametriGlobaliRow {
        export const idProperty = 'IdUtenteProdottoParametriGlobali';
        export const nameProperty = 'PunteggioNome';
        export const localTextPrefix = 'Gamification.UtentiParametriGlobali';
        export const lookupKey = 'Gamification.UtentiParametriGlobali';

        export function getLookup(): Q.Lookup<UtentiParametriGlobaliRow> {
            return Q.getLookup<UtentiParametriGlobaliRow>('Gamification.UtentiParametriGlobali');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoParametriGlobali = "IdUtenteProdottoParametriGlobali",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdentifierPunteggio = "IdentifierPunteggio",
            PunteggioNome = "PunteggioNome",
            PunteggioValore = "PunteggioValore",
            IdentifierCrediti = "IdentifierCrediti",
            CreditiNome = "CreditiNome",
            CreditiValore = "CreditiValore",
            IdentifierEsperienza = "IdentifierEsperienza",
            EsperienzaNome = "EsperienzaNome",
            EsperienzaValore = "EsperienzaValore",
            IdentifierLivello = "IdentifierLivello",
            Livello = "Livello"
        }
    }
}
